import committee from "./committee";
import merchant from "./merchant";
import notice from "./notice";
import app from "./app";
import wx from "./wx";
import other from "./other";
import telephoneExpenses from "./telephone-expenses";

const routes = [
  ...committee,
  ...merchant,
  ...notice,
  ...app,
  ...wx,
  ...other,
  ...telephoneExpenses,
];

export default routes;
